import { getAuthToken, getPortalType, getUserData } from './auth';

export const LIVE_CLASS_RECOVERY_KEY = 'budlee-live-class-recovery-v1';
const MAX_AGE = 6 * 60 * 60 * 1000;

export function discardRecovery() {
  try { sessionStorage.removeItem(LIVE_CLASS_RECOVERY_KEY); } catch { /* Storage unavailable. */ }
}

export function rememberRecovery(data) {
  discardRecovery();
  const portal = data?.sessionDetails?.role === 'tutor' ? 'teacher' : getPortalType();
  const userId = getUserData(portal)?.id;
  if (!data?.bookingId || !userId || !getAuthToken(portal)) return;
  try {
    // Never persist LiveKit credentials or the document that triggered a reload.
    sessionStorage.setItem(LIVE_CLASS_RECOVERY_KEY, JSON.stringify({
      bookingId: data.bookingId, portal, userId: String(userId), timestamp: Date.now(),
    }));
  } catch { /* Recovery is optional when storage is unavailable. */ }
}

export function readRecovery() {
  try {
    const marker = JSON.parse(sessionStorage.getItem(LIVE_CLASS_RECOVERY_KEY));
    if (!marker) return null;
    if (!['teacher', 'student'].includes(marker.portal) || !marker.bookingId ||
        !Number.isFinite(marker.timestamp) || marker.timestamp > Date.now() ||
        Date.now() - marker.timestamp > MAX_AGE ||
        marker.portal !== getPortalType() ||
        marker.userId !== String(getUserData(marker.portal)?.id) || !getAuthToken(marker.portal)) {
      discardRecovery();
      return null;
    }
    return marker;
  } catch { discardRecovery(); return null; }
}

export function restoredSession(data) {
  if (!data.booking_id || !data.token || !data.url) throw new Error('Invalid classroom admission');
  return {
    bookingId: data.booking_id, token: data.token, livekitUrl: data.url,
    sessionDetails: {
      bookingDate: data.booking_date, startTime: data.start_time, endTime: data.end_time,
      scheduledStartUtc: data.scheduled_start_utc, scheduledEndUtc: data.scheduled_end_utc,
      subjectName: data.subject_name, chapterName: data.chapter_name,
      tutorName: data.tutor_name, studentName: data.student_name, role: data.role,
      studentBoardId: data.student_board_id, studentBoardName: data.student_board_name,
      studentGradeId: data.student_grade_id, studentGradeName: data.student_grade_name,
    },
  };
}
